import { Table } from '@otp/ui';
import { getTableConfig } from './restaurants-assigned-list-config';
import {
  StoresUserDetailsDocument,
  StoresUserDetailsQuery,
  User,
} from 'src/graphql/generated/graphql';
import { useState } from 'react';
import { useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';

type RestaurantAssignnedListProps = {
  user: Partial<User>;
  withoutActions?: boolean;
};

const PAGINATION_LIMIT = 5;

export const RestaurantAssignedList = ({
  user,
  withoutActions = false,
}: RestaurantAssignnedListProps) => {
  const { t } = useTranslation();
  const [page, setPage] = useState(0);

  const filters = {
    organizationId: user.organizationId,
    assignedToUserId: user.id,
  };
  const { data } = useQuery<StoresUserDetailsQuery>(StoresUserDetailsDocument, {
    variables: {
      userId: user.id,
      filter: filters,
      pagination: {
        limit: PAGINATION_LIMIT,
        offset: page * PAGINATION_LIMIT,
      },
    },
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-only',
  });

  const totalCount = data?.stores?.pagination?.totalCount;
  const stores = data?.stores?.records || [];

  const tableConfig = getTableConfig({ stores, user, withoutActions }, { t });

  const title = `${t('user-details.stores-assigned', 'Stores assigned')} (${totalCount})`;

  return (
    <Table
      title={title}
      data={stores}
      columns={tableConfig}
      options={{
        page,
        sort: false,
        count: totalCount,
        rowsPerPage: PAGINATION_LIMIT,
        onChangePage: setPage,
      }}
    />
  );
};
